import * as React from 'react'

const SvgIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width={props.width || '42'}
    height={props.height || '44'}
    viewBox='0 0 42 44'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.94737 19.8H5.52632V35.2H9.94737V19.8ZM23.2105 19.8H18.7895V35.2H23.2105V19.8ZM42 39.6H0V44H42V39.6ZM36.4737 19.8H32.0526V35.2H36.4737V19.8ZM21 4.972L32.5168 11H9.48316L21 4.972ZM21 0L0 11V15.4H42V11L21 0Z'
      fill='#1D1D1F'
    />
  </svg>
)

export default SvgIcon
